import { LoanCategoryDTO } from "./loan-categories.dto";
import { Injectable } from "@nestjs/common";
import { LoanCategory } from "../loan-categories.entity";

@Injectable()
export class LoanCategoryAdapter{

    public convertDtoToEntity(loanCatDTO: LoanCategoryDTO, isUpdate: boolean = false): LoanCategory{
        const loanCatEntity = new LoanCategory();
        loanCatEntity.loanCategoryId = loanCatDTO.loanCategoryId;
        loanCatEntity.loanCategoryName = loanCatDTO.loanCategoryName;
        loanCatEntity.isActive = loanCatDTO.isActive === undefined ? true : loanCatDTO.isActive;
        if(isUpdate){
            loanCatEntity.updatedUser = loanCatDTO.updatedUser;
        }else{
            loanCatEntity.isActive = true;
            loanCatEntity.createdUser = loanCatDTO.createdUser;
        }
        return loanCatEntity;
    }

    public convertEntityToDto(loanCatObject: LoanCategory): LoanCategoryDTO{
        const loanCatDTO = new LoanCategoryDTO;
        loanCatDTO.loanCategoryId = loanCatObject.loanCategoryId;
        loanCatDTO.loanCategoryName = loanCatObject.loanCategoryName;
        loanCatDTO.isActive = loanCatObject.isActive;
        loanCatDTO.createdAt = loanCatObject.createdAt;
        loanCatDTO.updatedAt = loanCatObject.updatedAt;
        loanCatDTO.updatedUser = loanCatObject.updatedUser;
        loanCatDTO.createdUser = loanCatObject.createdUser;
        loanCatDTO.versionFlag = loanCatObject.versionFlag;
        return loanCatDTO;

    }
}